import { useAuth } from "../context/AuthContext";
import AdminDashboard from "../pages/dashboards/AdminDashboard";
import StudentDashboard from "../pages/dashboards/StudentDashboard";
import FacultyDashboard from "../pages/dashboards/FacultyDashboard";
import ParentDashboard from "../pages/dashboards/ParentDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  const role = user?.role || "admin";
  if (role === "student") return <StudentDashboard />;
  if (role === "faculty") return <FacultyDashboard />;
  if (role === "parent") return <ParentDashboard />;
  return <AdminDashboard />;
}
